import React from "react";
import styles from "./modal-buttons.module.scss";
import { CtaLink } from "../CtaLink";
import classnames from "classnames";
import { Button } from "@whatslly/ui-components/v2/Button";
import { useTranslation } from "react-i18next";
import UITypes from "@whatslly/types/UI-V2/UITypes";

type ModalButtonsType = {
  isSubmitDisabled?: boolean;
  className?: string;
  testId?: string;
  onCancel?: VoidFunction;
  submitText?: React.ReactNode;
  cancelText?: React.ReactNode;
  hideSubmit?: boolean;
  hideCancel?: boolean;
  onSubmit?: VoidFunction;
  href?: string;
  topBorder?: boolean;
  submitPaddingInline?: UITypes["paddingInlineType"];
  isSubmitting?: boolean;
  buttonType?: "submit" | "reset" | "button";
};

export const ModalButtons: React.FC<ModalButtonsType> = (props) => {
  const { t } = useTranslation();
  const { isSubmitDisabled, onCancel, submitText, cancelText, hideCancel, hideSubmit, topBorder } = props;
  const CancelButton = (
    <div data-testid={`modal-buttons-cancel-button`} className={classnames(styles.cancel, styles.transparentButton)}>
      <CtaLink onClick={() => onCancel?.()}>{cancelText ?? t("actions_cancel")}</CtaLink>
    </div>
  );

  const SubmitButton = (
    <div className={styles.submit}>
      <Button
        data-testid={props.testId}
        fontWeight="default"
        paddingInline={props.submitPaddingInline ?? "large"}
        disabled={isSubmitDisabled}
        onClick={props.onSubmit}
        isSubmitting={props.isSubmitting}
        type={props.buttonType}
      >
        {submitText ?? t("ok")}
      </Button>
    </div>
  );

  return (
    <div className={classnames(styles.buttonsContainer, props.className, { [styles.topBorder]: topBorder })}>
      {!hideCancel && CancelButton}
      {!hideSubmit && SubmitButton}
    </div>
  );
};
